module.exports = __webpack_public_path__ + "img/trade.15aed338.png";